import LoginView from '../../pages/LoginView';

// Nome simples (PT): Página de Login
export default function PaginaLogin(props) {
  return <LoginView {...props} />;
}






